import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { FilterAltOffRounded, SearchOffRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoGroupContactsFound = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.contactsGroup.notFound.primary')}
            secondary={t('prompts:noData.contactsGroup.notFound.secondary')}
            Icon={SearchOffRounded}
            action={
                <Button
                    startIcon={<FilterAltOffRounded />}
                    variant="tonal"
                    color="secondary"
                    LinkComponent={Link}
                    to="."
                    search={({ contact_group_item__status }) => ({
                        contact_group_item__status,
                    })}
                >
                    {t('Clear Filters')}
                </Button>
            }
        />
    );
};

export default NoGroupContactsFound;
